/**
 *  @desc router name 路由命名空间(按业务模块定义)
 */

export const HOMEPAGE = 'Homepage';
export const ABOUT = 'About';

export const ROLEMANAGE = 'RoleManage';
export const USERMANAGE = 'UserManage';

export const CUSTOMERLIST = 'CustomerList';
export const VEHICLELIST = 'VehicleList';
export const VEHICLEINSURANCECLUESLIST = 'VehicleInsuranceCluesList';
export const VEHICLEINSURANCELIST = 'VehicleInsuranceList';
export const CUSTOMERIMPORT = 'CustomerImport';

export const COLLISIONLIST = 'CollisionList';
export const COLLISIONSETTING = 'CollisionSetting';

export const APPOINTMENTBOARD = 'AppointmentBoard';
export const APPOINTMENTSETTING = 'AppointmentSetting';
export const SHOPSETTING = 'ShopSetting';

export const APPOINTMENTORDER = 'AppointmentOrder';

export const COUPONLIST = 'CouponList';
export const COUPONVERIFY = 'CouponVerify';

export const CREATEACTIVITY = 'CreateActivity';

export const COUPONSENDLIST = 'CouponSendList';
export const ACTIVITYLIST = 'ActivityList';

export const KLICENADLIST = 'KlicenAdList';

export const VERSIONRECORD = 'VersionRecord';

export const SERVICEAD = 'ServiceAdList';

export const MINIAPPADLIST = 'MiniAppAdList';

export const HELPCENTER = 'HelpCenter';

export const RADIALVEHICLE = 'RadiationVehicles';

export const FREQUENTLOCATIONS = 'FrequentLocations';
export const MAINTAINREMIND = 'MaintainRemind';

export const MAINTAINSETTING = 'MaintainSetting';

export const ARRIVEREMIND = 'ArriveRemind';
export const VEHICLEENTRY = 'VehicleEntry';

export const SubsidyApply = 'SubsidyApply';

export const LABELMANAGE = 'LabelManage';

export const LABELCLASSIFICATION = 'LabelClassification';

export const FEEDBACK = 'Feedback';

export const POPUPADLIST = 'PopupAdList';

export const ORDERIMPORT = 'OrderImport';

export const PAYLIST = 'PayList';

export const REPAIRRECORD = 'RepairRecord';

export const NOTBACKSTATISTICS = 'NotBackStatistics';
export const BACKSTORESTATISTICS = 'BackStoreStatistics';

export const STATUSDISTRIBUTESTATISTICS = 'StatusDistributeStatistics';

export const ACCIDENTDISTANCESTATISTICS = 'AccidentDistanceStatistics';

export const REPAIRMONEYSTATISTICS = 'RepairMoneyStatistics';

export const SCRATCHRECORD = 'ScratchRecord';

export const WINDOWRECORD = 'WindowRecord';

export const FIXRECORD = 'FixRecord';

export const DISCOUNTRECORD = 'DiscountRecord';
export const ACCIDENTFOLLOW = 'AccidentFollow';

export const TRAVELRECORD = 'TravelRecord';

export const CLUEPAYSTATISTICS = 'CluePayStatistics';

// export const COINMANAGE = 'CoinRecord';
export const COINRECORD = 'CoinRecord';

export const COINSUM = 'CoinSum';

export const LOSSINGSTAT = 'LossingStat';

export const SHOPMANAGE = 'ShopManage';

export const GOODSMANAGE = 'GoodsManage';
export const POINTSGOODS = 'PointsGoods';

export const INVENTORYMANAGE = 'InventoryManage';

export const ORDERMANAGE = 'OrderManage';

export const OVERVIEWSTATISTICS = 'OverviewStatistics';

export const MAINTENANCEWORKORDER = 'MaintenanceWorkOrder';
export const REPAIRWORKORDER = 'RepairWorkOrder';
export const WORKORDEROVERVIEW = 'WorkOrderOverview';
export const WORKORDERX3OVERVIEW = 'WorkOrderX3Overview';
export const PACKAGELIST = 'PackageList';
export const WORKORDERCONFIG = 'WorkOrderConfig';

export const USED_CAR_CHECK = 'UsedCarCheck';
export const USED_CAR_MANAGE = 'UsedCarVehicleManage';

export const VIP_MANAGEMENT = 'VipManagement';
export const VIP_LEVEL = 'VipLevel';
export const VIP_EQUITY = 'VipEquity';

export const VIP_TASK = 'VipTask';
export const GOODS_GROUP = 'GoodsGroup';
